import { siteInfo } from "@/mocks/site";
import { buildWhatsAppLink } from "@/utils/whatsapp";
import Reveal from "./Reveal";
import SectionHeading from "./SectionHeading";

const steps = [
  {
    number: "01",
    icon: "ri-search-eye-line",
    title: "Hizmetinizi Seçin",
    description: "İlgilendiğiniz hizmet veya kampanyayı belirleyin.",
  },
  {
    number: "02",
    icon: "ri-whatsapp-line",
    title: "WhatsApp’tan Bilgi Alın",
    description: "Uygulama kapsamını ve uygun randevu saatlerini sorun.",
  },
  {
    number: "03",
    icon: "ri-calendar-check-line",
    title: "Randevunuzu Planlayın",
    description: "Size uygun gün ve saat için görüşmenizi tamamlayın.",
  },
];

export default function Process() {
  return (
    <section className="emerald-canvas relative overflow-hidden py-16 md:py-24">
      <div
        className="pointer-events-none absolute left-1/2 top-0 h-72 w-72 -translate-x-1/2 rounded-full bg-accent-500/10 blur-3xl"
        aria-hidden="true"
      />

      <div className="relative mx-auto w-full max-w-7xl px-5 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="Nasıl İlerliyor?"
            tone="light"
            title="Üç Adımda Randevunuz Hazır"
            description="Karmaşık adımlar yok. Hizmetinizi seçin, WhatsApp üzerinden bilgi alın ve randevunuzu planlayalım."
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {steps.map((step, index) => (
            <Reveal key={step.number} delay={index * 110} className="h-full">
              <article className="relative flex h-full flex-col rounded-xl border border-accent-500/25 bg-primary-950/40 p-7">
                <span className="absolute right-6 top-6 font-heading text-4xl font-semibold text-accent-500/30">
                  {step.number}
                </span>

                <span className="flex h-14 w-14 items-center justify-center rounded-full border border-accent-500/60 bg-primary-900/60">
                  <i className={`${step.icon} text-2xl text-accent-400`} aria-hidden="true" />
                </span>

                <h3 className="mt-6 font-heading text-xl font-semibold tracking-tight text-background-50">
                  {step.title}
                </h3>

                <p className="mt-3 font-body text-sm leading-relaxed text-background-300">
                  {step.description}
                </p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={200}>
          <div className="mt-12 flex justify-center">
            <a
              href={buildWhatsAppLink(siteInfo.defaultMessage)}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-8 py-4 font-label text-xs font-semibold uppercase tracking-[0.16em] text-primary-950 transition-colors hover:bg-accent-400 md:text-sm"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-whatsapp-line text-base" aria-hidden="true" />
              </span>
              WhatsApp’tan Bilgi Al
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}